<!-- SOLAPA «BITÁCORA»: una línea por llamada, incluidas las que no se hicieron. -->
<div class="space-y-6 pt-2">

  <!-- ══ Los filtros ═════════════════════════════════════════════════════════ -->
  <section class="kb-tarjeta">
    <div class="flex flex-col gap-4 px-6 lg:flex-row lg:flex-wrap lg:items-end">
      <div>
        <span class="mb-1.5 block text-xs text-muted-foreground">Cómo terminó</span>
        <div class="flex flex-wrap gap-1.5" role="group" aria-label="Filtrar por cómo terminó">
          <button type="button" class="kb-chip" *ngFor="let e of ESTADOS"
                  [class.kb-chip-activo]="estado === e" [attr.aria-pressed]="estado === e"
                  (click)="elegirEstado(e)">{{ e ? ETIQUETA_ESTADO[e] : 'Todo' }}</button>
        </div>
      </div>

      <div class="w-full sm:w-52">
        <label class="mb-1.5 block text-xs text-muted-foreground" for="bit-agente">Agente</label>
        <div class="kb-select-envoltorio">
          <select id="bit-agente" class="kb-select" [(ngModel)]="agente" (ngModelChange)="aplicar()">
            <option value="">Todos los agentes</option>
            <option *ngFor="let a of agentes" [value]="a">{{ tituloAgente(a) }}</option>
          </select>
          <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
        </div>
      </div>

      <div class="w-full sm:w-44">
        <label class="mb-1.5 block text-xs text-muted-foreground" for="bit-tipo">Tipo</label>
        <div class="kb-select-envoltorio">
          <select id="bit-tipo" class="kb-select" [(ngModel)]="tipo" (ngModelChange)="aplicar()">
            <option value="">Todos los tipos</option>
            <option *ngFor="let t of TIPOS" [value]="t">{{ ETIQUETA_TIPO[t] }}</option>
          </select>
          <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
        </div>
      </div>

      <div class="w-full sm:w-56">
        <label class="mb-1.5 block text-xs text-muted-foreground" for="bit-comercio">Comercio</label>
        <div class="kb-select-envoltorio" *ngIf="comercios.length">
          <select id="bit-comercio" class="kb-select" [(ngModel)]="comercio" (ngModelChange)="aplicar()">
            <option value="">Todos los comercios</option>
            <option *ngIf="comercio && !comercioEnLista(comercio)" [value]="comercio">{{ comercio }}</option>
            <option *ngFor="let c of comercios" [value]="c.codigo">{{ c.nombre || c.codigo }} · {{ c.codigo }}</option>
          </select>
          <i class="fas fa-chevron-down kb-select-flecha" aria-hidden="true"></i>
        </div>
        <!-- Sin la lista de comercios, el código a mano. -->
        <input *ngIf="!comercios.length" id="bit-comercio" class="kb-input font-mono uppercase" type="text"
               placeholder="Código, p. ej. MT" [(ngModel)]="comercio" (keydown.enter)="aplicar()" (blur)="aplicar()">
      </div>

      <div>
        <span class="mb-1.5 block text-xs text-muted-foreground">Entre</span>
        <div class="flex items-center gap-2">
          <input type="date" class="kb-input w-[9.5rem]" aria-label="Desde" [(ngModel)]="desde" (change)="aplicar()">
          <span class="text-xs text-muted-foreground">y</span>
          <input type="date" class="kb-input w-[9.5rem]" aria-label="Hasta" [(ngModel)]="hasta" (change)="aplicar()">
        </div>
      </div>

      <button type="button" class="kb-btn kb-btn-ghost kb-btn-sm lg:mb-0.5" *ngIf="hayFiltros" (click)="limpiar()">
        <i class="fas fa-times !text-foreground" aria-hidden="true"></i>Limpiar filtros
      </button>
    </div>

    <div class="kb-tarjeta-cuerpo">
      <p class="m-0 text-sm text-muted-foreground">
        Una línea por pregunta, por prueba y por cada llamada al modelo, incluidas las que no se hicieron. Se guarda 90 días.
      </p>

      <div *ngIf="cargando" class="space-y-2" aria-live="polite" aria-busy="true">
        <div class="kb-skeleton h-9 w-full" *ngFor="let s of [1,2,3,4,5,6]"></div>
      </div>

      <div class="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-border px-4 py-3"
           *ngIf="!cargando && error" role="alert">
        <p class="m-0 text-sm">
          <i class="fas fa-exclamation-circle mr-1.5 text-destructive" aria-hidden="true"></i>
          No se pudo leer la bitácora. <span class="text-muted-foreground">{{ error }}</span>
        </p>
        <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" (click)="traer(filas.length)">
          <i class="fas fa-redo !text-foreground" aria-hidden="true"></i>Reintentar
        </button>
      </div>

      <div class="kb-empty" *ngIf="!cargando && !error && !filas.length">
        <span class="kb-empty-icono"><i class="fas fa-stream" aria-hidden="true"></i></span>
        <p class="kb-empty-titulo">{{ hayFiltros ? 'No hay ninguna línea con esos filtros' : 'Todavía no hay nada anotado' }}</p>
        <p class="kb-empty-texto" *ngIf="!hayFiltros">Cada pregunta al asistente, y cada prueba desde esta consola, deja su línea aquí.</p>
        <button type="button" class="kb-btn kb-btn-outline mt-4" *ngIf="hayFiltros" (click)="limpiar()">Limpiar filtros</button>
      </div>

      <ng-container *ngIf="!cargando && filas.length">
        <div class="kb-tabla-plana">
          <table class="kb-table">
            <thead class="kb-thead">
              <tr>
                <th class="kb-th">Cuándo</th>
                <th class="kb-th">Comercio</th>
                <th class="kb-th">Tipo</th>
                <th class="kb-th">Cómo terminó</th>
                <th class="kb-th">Qué pasó</th>
                <th class="kb-th hidden 2xl:table-cell">Modelo</th>
                <th class="kb-th kb-th-num hidden xl:table-cell">Tardó</th>
                <th class="kb-th kb-th-num">Costo</th>
                <th class="kb-th w-8"><span class="sr-only">Abrir</span></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let r of filas; let i = index">
                <tr class="kb-tr kb-tr-clic" tabindex="0" role="button" [attr.aria-expanded]="abierta === idDe(r, i)"
                    (click)="alternar(r, i)" (keydown.enter)="alternar(r, i)">
                  <td class="kb-td whitespace-nowrap text-xs text-muted-foreground" [title]="fechaHora(r.creadoEl)">{{ fechaCorta(r.creadoEl) }}</td>
                  <td class="kb-td">
                    <span *ngIf="r.comercio">{{ nombreComercio(r.comercio) }}</span>
                    <span class="text-muted-foreground" *ngIf="!r.comercio">—</span>
                  </td>
                  <td class="kb-td whitespace-nowrap">{{ etiquetaFila(r) }}</td>
                  <td class="kb-td"><span class="kb-badge" [ngClass]="BADGE_ESTADO[r.estado] || 'kb-badge-neutro'">{{ ETIQUETA_ESTADO[r.estado] || r.estado }}</span></td>
                  <td class="kb-td">
                    <!-- Para lo omitido y lo fallado, el motivo ES la noticia; para lo demás, la pregunta.
                         Dos renglones como mucho: la columna se achica sin empujar «Costo» fuera de la vista. -->
                    <span class="line-clamp-2 min-w-[10rem]" *ngIf="r.estado === 'OK'">{{ r.pregunta || '—' }}</span>
                    <span class="line-clamp-2 min-w-[10rem] text-muted-foreground" *ngIf="r.estado !== 'OK'">{{ motivoLegible(r.motivo) || r.pregunta || 'sin motivo anotado' }}</span>
                  </td>
                  <td class="kb-td hidden whitespace-nowrap text-xs text-muted-foreground 2xl:table-cell">{{ r.modeloId || '—' }}</td>
                  <td class="kb-td kb-td-num hidden whitespace-nowrap text-muted-foreground xl:table-cell">{{ ms(r.latenciaMs) }}</td>
                  <td class="kb-td kb-td-num whitespace-nowrap" [title]="usd(r.costoUsd)">{{ usdCorto(r.costoUsd) }}</td>
                  <td class="kb-td">
                    <i class="fas fa-chevron-right text-xs text-muted-foreground transition-transform"
                       [class.rotate-90]="abierta === idDe(r, i)" aria-hidden="true"></i>
                  </td>
                </tr>
                <tr *ngIf="abierta === idDe(r, i)">
                  <td class="kb-td kb-fondo-suave" colspan="9">
                    <app-ia-registro [registro]="r"></app-ia-registro>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <div class="flex flex-wrap items-center justify-between gap-3">
          <p class="kb-barra-nota m-0">{{ nf(filas.length) }} de {{ nf(total) }}</p>
          <button type="button" class="kb-btn kb-btn-outline kb-btn-sm" *ngIf="filas.length < total"
                  [disabled]="trayendoMas" (click)="traer(filas.length)">
            <i class="fas" [ngClass]="trayendoMas ? 'fa-circle-notch fa-spin' : 'fa-chevron-down'" aria-hidden="true"></i>Ver más
          </button>
        </div>
      </ng-container>
    </div>
  </section>
</div>
